import React, { useState, useEffect } from 'react';
import { List, SetAsReturned, cancelAsReturned } from '../services/kit.service';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { BiLoaderCircle } from 'react-icons/bi';
import { useNavigate } from "react-router-dom";
import LoaderStatus from '../components/common/LoaderComponent';
import AsideLeft from './AppAdminComponents/AsideLeft';
import { getuser } from '../helpers/user.helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import formatDate from '../helpers/date.helper';
import Footer from '../components/Footer';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';


export default function KitsList() {
    let navigate = useNavigate();
    const [kits, setKits] = useState(undefined);

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let array_response = await List('kits');

            setKits(array_response?.data);
        }

        fetchData();
    }, [kits]);


    let state = [];

    let showItensClick = (rowData) => {
        navigate(`/kit/${rowData.codmovenda}`);
    }

    let setDevolutionKit = async (rowData) => {
        await SetAsReturned(rowData.numped)
    }

    let cancelDevolutionKit = async (rowData) => {
        await cancelAsReturned(rowData.numped)
    }


    let devolutionButton = (rowData, column) => {
        return (
            <div>
                {
                    rowData.coD_DEVOLUTION &&
                    <button onClick={() => cancelDevolutionKit(rowData)} title="Cancelar" type="button" className="btn btn-icon btn-sm btn-warning">Cancelar devolução</button>
                }

                {
                    !rowData.coD_DEVOLUTION &&
                    <button onClick={() => setDevolutionKit(rowData)} title="Cancelar" type="button" className="btn btn-icon btn-sm btn-primary">Devolver kit</button>
                }

            </div>
        )
    }

    let optionButtons = (rowData, column) => {
        return (
            <div>
                <button onClick={() => showItensClick(rowData)} title="Ver produtos" type="button" className="btn btn-icon btn-sm btn-secondary">Ver produtos</button>
            </div>
        )
    }

    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft option="kits" />
                <>
                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6">
                                        <h1 className="m-0 text-dark">Kits</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    {/* Left col */}
                                    <section className="col-lg-12 connectedSortable">
                                        {/* Custom tabs (Charts with tabs)*/}
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">
                                                    <i className="fas fa-chart-pie mr-1" />Meus Kits
                                                </h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="tab-content p-0">
                                                    {!kits ? (
                                                        <LoaderStatus />
                                                    ) : (
                                                        <DataTable
                                                            value={kits}
                                                            style={{ marginBottom: 50 }}
                                                            responsive className="p-datatable-customers"
                                                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                            paginator="true"
                                                            rowsPerPageOptions={[10, 20, 50]}
                                                            rows={10}
                                                            emptyMessage="Sem dados para exibir"
                                                        >
                                                            <Column field="codmovenda" header="Cód. da Venda" filter={true} />
                                                            <Column field="numped" header="Num. Ped" filter={true} />
                                                            <Column field={(row) => formatDate(row.data)} header="Data" />
                                                            <Column field="nomecli" header="Cliente" filter={true} sort={true} />
                                                            <Column field={(row) => row.cOD_DEVOLUTION ? 'SIM' : 'NÃO'} header="Devolvido" sort={true} />
                                                            <Column key="123" body={devolutionButton} header="Data" bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                                            <Column key="123" body={optionButtons} bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                                        </DataTable>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                </div>
                            </div>
                        </section>
                    </div>
                </>
                <Footer />
            </div>
        </>
    )
}
